import React from "react";
import PropTypes from "prop-types";
import styles from "./Profile.css";

const profile = ({ display, details }) => {
  let displayClass = [styles.Profile, styles.ProfileActive];
  if (!display) {
    displayClass = [styles.Profile, styles.ProfileHidden];
  }

  const contactItems = details.contact.map(({ name, value }) => (
    <div className={styles.contactItem}>
      <span className={styles.contactName}>{name}</span>
      <span className={styles.contactValue}>{value}</span>
    </div>
  ));

  return (
    <section className={displayClass.join(" ")}>
      <div className={styles.profileBox}>
        <div className={styles.Image} />
        <div className={styles.profileAbout}>
          <h1>{details.fullName}</h1>
          <h3>{details.positionHeadline}</h3>
        </div>
      </div>
      <div className={styles.contactBox}>{contactItems}</div>
    </section>
  );
};

profile.propTypes = {
  display: PropTypes.bool.isRequired,
  details: PropTypes.instanceOf(Object).isRequired
};

export default profile;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Profile/Profile.js